import React from "react";
import { OmniStyleComponent, OmniTableStickyComponent, OmniIconComponent, AccordionComponent, AlertMessagesService, LoaderComponent, Utils } from "../../../../shared";
import { PlacementDetailsTableService, CreatePlacementOrPackageService } from "../../";
import { html } from 'lit';

export class PlatformDetailDialogComponent extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { 
      parentObject: {},
      spinnerCount:false,
      isPlatformModalOpen:false,
      platformTableDataList : props.plateformModalData || []
     };
  }

  componentWillReceiveProps(props){
    const data = props.plateformModalData;
    // const parentObject = props.placementNestedData.find(item => item.id === data[0].parentId);
    this.setState({
        spinnerCount: 0,
        // parentObject,
        platformTableDataList: data,
        isPlatformModalOpen: props.isPlatformModalOpen,
    })
  }
  handleModalClick = (event) => {
    event.stopPropagation();
  };

  /** The below code is defining a function called "close" in JavaScript. Inside the function, it is
   * using the "setState" method to update the state of the component. It sets the
   * "isPlacementModalOpen" property to false, the "editPlacementName" property to false, and the
   * "ProgrammaticPackageData" property to null, "programmaticPkgForm" property to null. 
   * Finally, it calls the "onDialogClose" method that is
   * passed as a prop to the component. 
   */
  close = () => {
    this.setState({ isPlatformModalOpen: false,});
    this.props.onDialogClose();
  };

  convertToCurrency = (value) => {
    const isNumber = typeof value === 'string' ? Number(value) : value;
    return isNumber?.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  
  getLeftColumn(){
    return  [
        {
            label: 'PLACEMENT NAME',
            key: 'placement_taxonomy',
            default: '',
            passthrough: true,
            template: (value, index) => {
                return html` 
                <Style>
                    :host::part(placement-name){
                    color: var(--color-almost-black);
                    }
                    :host::part(wrapText){
                        display: flex;
                        flex-wrap: wrap;
                        white-space: normal;
                        line-height: 20px;
                        max-height: 40px;
                        overflow: hidden;
                    }
                    :host::part(wordBreak){
                        word-break: break-all;
                    }
                </Style>
                <td part="table-body-cell placement-name">
                    <span part=" wordBreak wrapText" style="width: 500px">
                        ${value.placement_taxonomy}
                    </span>    
                </td>`
            }
          },
      
      {
          label: 'TYPE',
          key: 'package_type',
          default: '',
          isSortable: false,
          passthrough: true,
          template: (value, index) => {
              let displayValue;
              if (value.package_type === 'DSP') {
                  displayValue = 'Placement (Line Item)';
              } else if (value.package_type === 'Child' && value?.parent_type === 'DSP') {
                  displayValue = 'Creative';
              }else if (value.package_type === 'Child' && value?.parent_type !== 'DSP') {
                  displayValue = 'Placement (Line Item)';
              } else if (value.package_type === 'DirectCreative' || value.package_type === 'Delivered') {
                  displayValue = 'Creative';
              } else {
                  displayValue = value.package_type;
              }
              return html`<td part="table-body-cell">
                  ${displayValue}
              </td>`
          }
      },
      {
        label: 'PARAMETER CODE',
        key: 'parameter_code',
        default: '',
        passthrough: true,
        template: (value, index) => {
            return html` 
            <style>
            :host::part(wrapText){
                        display: flex;
                        flex-wrap: wrap;
                        white-space: normal;
                        line-height: 20px;
                        max-height: 40px;
                        overflow: hidden;
                    }
                    :host::part(wordBreak){
                        word-break: break-all;
                    }
            </style>
            <td part="table-body-cell">
                <span part="wrapText wordBreak" style="width: 500px">
                    ${value.parameter_code}
                </span>    
            </td>`
        }
      },
      {
          label: 'BUDGET',
          key: '',
          default: '',
          isSortable: false,
          passthrough: true,
          template: (value, index) => {
            const condition = value?.net_spend > value?.planned_cost;
            const plannedCost = value?.planned_cost;
            return html`
            <Style>
                :host::part(budget-cell){
                    display: flex;
                    align-items: center;
                }
                :host::part(error-color){
                    color: var(--color-error);
                }
                :host::part(bugdet-money-icon){
                    fill: var(--color-primary);
                    margin-right: 5px;
                }
            </Style>
            <td part="table-body-cell budget-cell ${condition ? 'error-color' : ''}">
                ${plannedCost && html`<omni-icon icon-id="omni:informative:financial" class="is-size-1" part="bugdet-money-icon"></omni-icon>`}
                ${value?.planned_cost && this.convertToCurrency(value?.planned_cost)}
            </td>`;
          }
      },
      {
        label: 'NET SPEND',
        key: 'net_spend',
        default: '',
        isSortable: false,
        passthrough: true,
        template: (value, index) => {
            const condition = value?.net_spend > value?.planned_cost;
            return html`
             <Style>
                :host::part(error-color){
                    color: var(--color-error);
                }
            </Style>
            <td part="table-body-cell ${condition ? 'error-color' : ''}">
              ${this.convertToCurrency(value?.net_spend)}
          </td>`;
        }
    },
    {
        label: 'IMPRESSIONS',
        key: '',
        default: '',
        isSortable: false,
        passthrough: true,
        template: (value, index) => {
            return html`<td part="table-body-cell">
            ${value?.impressions}
          </td>`;
        }
    },
    {
        label: 'Platform Name',
        key: 'platform_name',
        default: '',
        isSortable: false,
        passthrough: true,
        template: (value, index) => {
            return html`<td part="table-body-cell">
            ${value?.platform_name}
          </td>`;
        }
    },
    {
        label: 'CLICKS',
        key: '',
        default: '',
        isSortable: false,
        passthrough: true,
        template: (value, index) => {
            return html`<td part="table-body-cell">
            ${value?.clicks}
          </td>`;
        }
    },
    {
        label: 'ACTIONS',
        key: '',
        default: '',
        isSortable: false,
        passthrough: true,
        template: (value, index) => {
            return html`<td part="table-body-cell">
            ${this.convertToCurrency(value?.actions)}
          </td>`;
        }
    },
    {
        label: 'UNITS',
        key: 'unit_amount',
        default: '',
        isSortable: false,
        passthrough: true,
        template: (value, index) => {
            return html`<td part="table-body-cell">
             ${value?.unit_amount}
            </td>`
        }
    },
    {
        label: 'RATE',
        key: 'rate',
        default: '',
        isSortable: false,
        passthrough: true,
        template: (value, index) => {
            return html`<td part="table-body-cell">
            ${value?.rate && this.convertToCurrency(value?.rate)}
            </td>`
        }
    },    
      {
        label: 'START DATE',
        key: 'flight_start',
        isSortable: false,
        passthrough: true,
        template: (value,index) => {
          const displayValue = Utils.formatDateObject(value.flight_start ? value.flight_start : '')
            return html`<td part="table-body-cell">
            ${displayValue}
            </td>`
        }
      },
      {
          label: 'END DATE',
          key: 'flight_end',
          default: '',
          isSortable: false,
          passthrough: true,
          template: (value,index) => {
            const displayValue = Utils.formatDateObject(value.flight_end? value.flight_end :'')
              return html`<td part="table-body-cell">
              ${displayValue}
              </td>`
          }
      }
  ];
  }

  getRightColumn(){
    return [
      {
        label: 'Status',
        key: 'status',
        default: '',
        isSortable: false,
        passthrough: true,
        template: (value,index) => {
            return html`<td part="table-body-cell">
            ${value?.status}
            </td>`
        }
    },
    ]
  }
  render() {
    return (
      <OmniStyleComponent>
        {this.state.isPlatformModalOpen && (
          <div className="platform-modal modal is-active">
            <div className="modal-content" onClick={this.handleModalClick}>
              <LoaderComponent
                spinnerCount={this.state.spinnerCount}
                displayWholePage={true}
              />
              <article className="message">
                <div>
                <div className="message-header">
                  <p className="object-title is-size-3">
                    { `In Platform Object Status`}
                  </p>
                    <omni-tooltip>
                        <button onClick={() => this.close(true)} className="button is-text" slot="invoker">
                            <OmniIconComponent iconId="omni:interactive:close" class="is-size-1"/>
                        </button>
                        <span slot="content">Close</span>
                    </omni-tooltip>
                </div>
                </div>
                <div className="message-body">
                  <div className="messag-body-note">
                      <p>
                        This status table displays all the objects of the same name across various platforms
                      </p>
                  </div>
                 
                   <div className="table-container"> 
                        <div className="table-header">
                            {/* <span className="platform-name">
                              Platform:
                            </span> */}
                            <button className="button is-text platform-link">
                                Link to the source <OmniIconComponent iconId="omni:interactive:launch" class="is-size-4"/>
                            </button>
                        </div>
                        <div className="table-body">
                          <OmniTableStickyComponent 
                          data={this.state.platformTableDataList}
                          leftColumns={this.getLeftColumn()}
                          rightColumns={this.getRightColumn()}    
                          id="platform-table"
                          keyFn={row => row && row?._uniqueKey}
                          >
                          </OmniTableStickyComponent>
                        </div>
                    </div>
                    
                  
                </div>
              </article>
            </div>
          </div>
        )}
      </OmniStyleComponent>
    );
  }
}